import { get } from "lodash";
import moment from "moment";

export const intlFormat = (intl, ...args) => {
  //duck-typing for sanity check (DON'T count on it too much)
  const formatMessage = get(intl, "formatMessage", false);
  if (formatMessage) {
    const messageObj = args[0] || {};
    const id = get(messageObj, "id", false);
    if (id) {
      return formatMessage(...args);
    } else {
      console.error("Expect non-empty id in localisation object ", messageObj); //eslint-disable-line no-console
    }
  } else {
    console.error("Wrong param for intl ", intl); //eslint-disable-line no-console
  }
};

export const formatDate = value => {
  const activeLocale = moment.locale();
  if (activeLocale === "zh-cn" || activeLocale === "zh-hk")
    return moment(value).format("YYYY年M月D日");
  return moment(value).format("DD MMM YYYY");
};
export const formatDateTime = (value) => {
  const activeLocale = moment.locale();
  if (activeLocale === "zh-cn" || activeLocale === "zh-hk")
    return moment(value).format("YYYY年M月D日 HH:mm");
  return moment(value).format("DD MMM YYYY HH:mm");
};



// WEBPACK FOOTER //
// ./i18n/util.js